import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../utils/AuthContext";
import { recordJourneyRendered } from "../utils/journeyTracking";

/** Place inside the content Suspense boundary, not in loading/redirect branches. */
export default function JourneyRendered({ teamId }: { teamId?: string }) {
  const location = useLocation();
  const { user } = useAuth();
  useEffect(() => {
    recordJourneyRendered(location.pathname, location.search, teamId);
  }, [user?.uid, location.pathname, location.search, location.key, teamId]);
  return null;
}
